import { isCnpj, isCpf, normalizarDocumento } from "utils/cpfcnpj-format";
import { validarCNPJ, validarCPF } from "utils/cpfcnpj-validate";
import { TipoField } from "./text-field-saurus-types";

function validador(value: string, tipo?: TipoField) {
  switch (tipo) {
    case "CPF":
      return ValidaCpf(value);
    case "CNPJ":
      return ValidaCnpj(value);
    case "CNPJ_CPF":
      return ValidaCnpjCpf(value);
    case "CNPJ_CPF_GERAL":
      return ValidaCnpjCpfGeral(value);
    case "HORA":
      return validaHora(value);
    default:
      return true;
  }
}

function ValidaCpf(value: string) {
  const mask = /^\d{3}[.]\d{3}[.]\d{3}[-]\d{2}$/;
  if (value.length === 0) {
    return true;
  }
  if (mask.test(value)) {
    return validarCPF(value);
  }
  return false;
}

function ValidaCnpj(value: string) {
  const mask = /^[A-Z0-9]{2}[.][A-Z0-9]{3}[.][A-Z0-9]{3}[/][A-Z0-9]{4}[-]\d{2}$/i;
  if (value.length === 0) {
    return true;
  }
  if (mask.test(value)) {
    return validarCNPJ(value);
  }
  return false;
}

function ValidaCnpjCpf(value: string) {
  const maskcpf = /^\d{3}[.]\d{3}[.]\d{3}[-]\d{2}$/;
  const maskcnpj = /^[A-Z0-9]{2}[.][A-Z0-9]{3}[.][A-Z0-9]{3}[/][A-Z0-9]{4}[-]\d{2}$/i;
  if (value.length === 0) {
    return true;
  }
  if (maskcpf.test(value)) {
    return ValidaCpf(value);
  }
  if (maskcnpj.test(value)) {
    return ValidaCnpj(value);
  }
  return false;
}

function validaHora(value: string) {
  var v = value;
  var mask = /^[0-2][0-3]:[0-5][0-9]:[0-5][0-9]/;

  if (mask.test(v)) {
    return true;
  } else if (v !== null && v !== "") {
    return false;
  }
}

function ValidaCnpjCpfGeral(value: string) {
  const normalizado = normalizarDocumento(value);
  if (isCpf(value) || isCnpj(value)) {
    return ValidaCnpjCpf(value);
  }
  if (normalizado.length === 0) {
    return true;
  }
  return true;
}

export { validador };
